import React from 'react';
import { Card } from 'react-bootstrap';
import Button from '../../Atoms/Buttons/';
import { ButtonVariant } from '../../types/IHeader';
import { ISubscribedFeedCard } from '../../types/ISubscribedFeedCard';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import './SubscribedFeedsCard.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const SubscribedFeedsCard = ({
  feedname,
  //   onInfoIconClick,
  showTrashIcon,
  onTrashIconClick,
  onButtonClick,
  onEnterClick,
  status,
  statusClass,
  className,
  buttonVariant,
  buttonText,
}: ISubscribedFeedCard) => {
  return (
    <Card
      className={`${className} subscribedfeed-card-container`}
      data-testid="subscribedfeeddata-card"
    >
      <div>
        <Card.Text className="card-text" data-testid="feed-name-text">
          {feedname}
          {/* <i
            data-testid="info-button"
            className="fa fa-info-circle"
            aria-hidden="true"
            onClick={() => onInfoIconClick()}
            tabIndex={0}
          ></i> */}
        </Card.Text>
        <div className="status-block">
          <span className={`${statusClass} status-indicator status-text`}>
            {status ? 'Disabled' : 'Active'}
          </span>
        </div>
      </div>
      <div className="button-container">
        {showTrashIcon && (
          <FontAwesomeIcon
            className="trash-icon"
            role="button"
            icon={faTrashCan as IconProp}
            onClick={onTrashIconClick}
            onKeyDown={onEnterClick}
            tabIndex={0}
          ></FontAwesomeIcon>
        )}
        <Button
          data-testid="subscribedfeed-card-button"
          className="card-button"
          onClick={() => onButtonClick()}
          variant={buttonVariant ? buttonVariant : ButtonVariant.OutlinePrimary}
          label={buttonText}
        />
      </div>
    </Card>
  );
};
export default SubscribedFeedsCard;
